<template>
  <template v-for="category in groupedOrderlines.keys()" :key="category.id">
    <div class="o-input">
      <label class="o-input__label">{{ category.title }}</label>
      <div class="o-input__controls">
        <div class="c-shopping-list">
          <template v-for="orderline in groupedOrderlines.get(category)" :key="orderline.productId">
            <div class="c-shopping-list__row">
              <div class="c-shopping-list__description">{{ orderline.productNode.value.title }}</div>
              <div class="c-shopping-list__price">
                {{ orderline.quantity || 1 }}
                <span class="u-text-times">×</span>
                <div class="c-shopping-list__price-label">{{ formatCurrency(orderline.productNode.value.costPerUnitWithVat) }} euro</div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import { useStore } from "vuex";
import { computed } from "vue";
import { formatCurrency } from "@/infrastructure/utilities";
import { orderBy } from "@/regira_modules/utilities/array-utility";

export default {
  setup() {
    const store = useStore();

    return {
      groupedOrderlines: computed(() => {
        const categories = store.state.data.categories;
        const orderlines = store.getters["orders/orderlines"];
        const productTree = store.state.data.productTree;
        const products = store.getters["data/products"];
        const orderlinesWithProducts = orderlines.map((ol) => ({ ...ol, productNode: productTree.find((pn) => pn.value.id === ol.productId) }));
        const categoriesWithOrderlines = categories
          .map((c) => [
            c,
            // respect sorting of data/products
            orderBy(
              orderlinesWithProducts.filter((ol) => ol.productNode.value.categoryId == c.id),
              (ol) => products.findIndex((p) => ol.productId == p.id)
            ),
          ])
          .filter(([, ol]) => ol.length);
        return new Map(categoriesWithOrderlines);
      }),
      formatCurrency,
    };
  },
};
</script>
